import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=1253c9b3&"
import script from "./Playground.vue?vue&type=script&lang=ts&"
export * from "./Playground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports